<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  // import LayoutVue from './components/Layout.vue'
  import axios from '@/utils/request';
  export default {
    name: 'Layout',
    // components: {
    //   LayoutVue
    // },
    created(){
      
    },
    methods:{
      getData(){
        axios.get('/user_info')
            .then(res => {
                if(res.code == 0){
                  this.$store.commit('setGlobalVar', res.data)
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
      }
    }
  }
</script>

<style>
body,html{
  background: #f2f2f2;
  height:100%
}
#app{
  height:100%
}
.el-menu{
  border-right:none !important;
}
*{
  margin: 0;
  padding: 0;
}
.merchart_header{
    padding: 15px 15px 0 15px;
}
.mian{
    padding: 15px;
}
.page{
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
.home{
  height:100%;
  background: #fff;
  border-radius: 5px;
  display:flex;
  flex-direction:column
}
.mian{
  flex:1;
}
.step_one .el-form-item__content{
  width: 500px;
}
.step_one .el-input--mini .el-input__inner{
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px;
}
.el-dialog{
  max-width: 700px;
}
.el-table th.el-table__cell>.cell{
  font-weight: normal !important;
}
.el-tabs__content{
  display: none !important;
}
.else_inputs .el-input-group__prepend{
  width:65px !important;
}
.else_inputs1 .el-input-group__prepend{
  width:80px !important;
}
.main__phone_item .el-input__inner{
  border: none !important;
  padding: 0 !important;
}
.el-image-viewer__canvas{
  height: 70% !important;
  margin-top: 8%;
}
.list_form .el-form-item{
  margin-bottom: 5px !important;
}
.el-table__row--level-1{
  background: #f6f6f6 !important;
}
.xfs_record .el-descriptions__body{
  background-color: #f6f6f6 !important;
}
.step_redixs .is-true i{
  color: #409eff !important;
}
.step_redixs .is-true{
  color: #409eff !important;
}
.el-menu-item:hover {
  background-color: rgba(37, 137, 255, 0.1) !important;  /* 修改为你的背景色 */
  color: #2589FF !important; /* 修改为你的文字颜色 */
}
.el-menu-item:hover a{
  color: #2589FF !important;
}
/* 筛选1行的样式 开始 */
.sxBtn{
  background-color: #ecf5ff;
    border-color: #d9ecff;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409EFF;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
    height: 34px;
    display: inline-table;
}
.sxBtn:hover{
  cursor: pointer;
  background: #409eff;
  color: #fff;
}
.filterCon_More{
    display: inline-table;
}
/* 筛选1行的样式 结束 */
</style>
